<div>
  <ng-content *ngTemplateOutlet="customSidebar ? customSidebar : defaultSidebar"></ng-content>
</div>

<ng-template #defaultSidebar>
  <div id="sidebarContainer" [style.top]="sidebarPositionTop">
    <div id="additionalSidebarContainer" [class.invisible]="!showSidebarButton">
      <pdf-sidebar-toolbar></pdf-sidebar-toolbar>
    </div>
    <pdf-sidebar-content [customThumbnail]="customThumbnail"></pdf-sidebar-content>
    <div id="sidebarResizer" class="hidden"></div>
  </div>
</ng-template>

